import { DegreeTypeText } from '../../../keyword-helper/enums/DegreeTypeText';
import { KeywordHelperType } from '../../../keyword-helper/enums/KeywordHelperType';
import { KeywordHelperContent } from '../../../keyword-helper/KeywordHelperContent';

class MoreSpecificMastersDefinition extends KeywordHelperContent {
	public constructor() {
		super(KeywordHelperType.BE_MORE_SPECIFIC, DegreeTypeText.MASTER);
	}
}

export default new MoreSpecificMastersDefinition();
